// Core packages
import { HttpClient, HttpHeaders } from "@angular/common/http";
// Third party packages
import moment from "moment";
import { EMPTY, Observable, of, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
// Custom packages
import { ConfigService } from "./config.service";
import * as i0 from "@angular/core";
import * as i1 from "./config.service";
import * as i2 from "@angular/common/http";
var OpenapiService = /** @class */ (function () {
    /**
     * Class constructor
     */
    function OpenapiService(configService, http) {
        this.configService = configService;
        this.http = http;
        this.httpOptions = {};
    }
    /**
     * Get an existing valid token or create one
     *
     * @returns string The valid API token
     */
    OpenapiService.prototype.getValidToken = function () {
        var _this = this;
        try {
            return new Observable(function (obs) {
                var basicAuth = btoa(_this.configService.openApiUsername + ":" + _this.configService.openAPiPassword);
                var token = '';
                // Get the list of valid OpenApi tokens
                var headers = new HttpHeaders().set('Authorization', "Basic " + basicAuth);
                var options = _this.httpOptions;
                options.headers = headers;
                _this.http
                    .get('https://oauth.openapi.it/token', options)
                    .pipe(catchError(_this.handleError))
                    .subscribe(function (res) {
                    if (res &&
                        res.success &&
                        res.data &&
                        Array.isArray(res.data)) {
                        // The token exists and verifies that at least one is valid
                        // Get tokens with valid scopes
                        var validTokens = res.data.filter(function (el) {
                            return el.scopes &&
                                Array.isArray(el.scopes) &&
                                el.scopes.some(function (scope) {
                                    return scope.toLowerCase().includes('imprese') || scope.toLowerCase().includes('visurecamerali');
                                });
                        });
                        // Get the first token valid for at least 24 hours
                        var validToken = validTokens.find(function (el) {
                            return moment.unix(el.expire).subtract(1, 'day').diff(moment(), 'day') > 0;
                        });
                        if (validToken && validToken.token) {
                            token = validToken.token;
                        }
                    }
                    if (!token || token === '') {
                        // A valid token does not already exist, so create one
                        var body = {
                            "scopes": [
                                "*:*.openapi.it/*",
                                "*:*.openapi.com/*"
                            ],
                        };
                        _this.http
                            .post('https://oauth.openapi.it/token', body, options)
                            .pipe(catchError(_this.handleError))
                            .subscribe(function (res) {
                            if (res &&
                                res.success &&
                                res.data) {
                                token = res.data.token;
                            }
                            obs.next(token);
                        }, function (error) {
                            console.warn(error);
                            return obs.error(error);
                        }, function () {
                            return obs.complete();
                        });
                    }
                    else {
                        obs.next(token);
                    }
                }, function (error) {
                    console.warn(error);
                    return obs.error(error);
                }, function () {
                    return obs.complete();
                });
            });
        }
        catch (error) {
            console.warn(error);
            return EMPTY;
        }
    };
    /**
    * Get an existing company by Vat number
    *
    * @param token OpenAPI token
    * @param vatNumber The company Vat number
    *
    * @returns object|null The company data found or null
    */
    OpenapiService.prototype.getCompanyByVatNumber = function (token, vatNumber) {
        var _this = this;
        try {
            return new Observable(function (obs) {
                var bearerToken = "Bearer " + token;
                var headers = new HttpHeaders().set('Authorization', "Basic " + bearerToken);
                var options = _this.httpOptions;
                options.headers = headers;
                var italyVataNumber = '';
                if (vatNumber && vatNumber.substring(0, 2).toUpperCase() === 'IT') {
                    italyVataNumber = vatNumber.slice(2);
                }
                else {
                    italyVataNumber = vatNumber;
                }
                var url = "https://company.openapi.com/IT-advanced/" + italyVataNumber;
                _this.http
                    .get(url, options)
                    .pipe(catchError(_this.handleError))
                    .subscribe(function (res) {
                    if (res &&
                        res.success &&
                        res.data) {
                        obs.next(res.data);
                    }
                    else {
                        obs.next();
                    }
                }, function (error) {
                    console.warn(error);
                    return obs.error(error);
                }, function () {
                    return obs.complete();
                });
            });
        }
        catch (error) {
            console.warn(error);
            return EMPTY;
        }
    };
    /**
    * Get an existing company by Name
    *
    * @param token OpenAPI token
    * @param companyName The company name
    *
    * @returns object|null The company data found or null
    */
    OpenapiService.prototype.getCompanyByCompanyName = function (token, companyName) {
        var _this = this;
        try {
            return new Observable(function (obs) {
                var bearerToken = "Bearer " + token;
                var headers = new HttpHeaders().set('Authorization', "Basic " + bearerToken);
                var options = _this.httpOptions;
                options.headers = headers;
                var url = "https://company.openapi.com/IT-search?dataEnrichment=address&radius=100000&province=MI&limit=10&companyName=" + companyName;
                _this.http
                    .get(url, options)
                    .pipe(catchError(_this.handleError))
                    .subscribe(function (res) {
                    if (res &&
                        res.success &&
                        res.data) {
                        obs.next(res.data);
                    }
                    else {
                        obs.next();
                    }
                }, function (error) {
                    console.warn(error);
                    return obs.error(error);
                }, function () {
                    return obs.complete();
                });
            });
        }
        catch (error) {
            console.warn(error);
            return EMPTY;
        }
    };
    /**
     * Handle http errors
     *
     * @since 1.0.0
     */
    OpenapiService.prototype.handleError = function (error) {
        // const message = error.error.message;
        // if (typeof context.toastrService !== 'undefined') {
        //   context.toastrService.error(message);
        // }
        if (error.status === 0) {
            return of(new Error("Unexpected error. Please reload the page and try again"));
        }
        return throwError(error);
    };
    OpenapiService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function OpenapiService_Factory() { return new OpenapiService(i0.ɵɵinject(i1.ConfigService), i0.ɵɵinject(i2.HttpClient)); }, token: OpenapiService, providedIn: "root" });
    return OpenapiService;
}());
export { OpenapiService };
